import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { DesitionBoxComponent } from 'src/app/modals/desition-box/desition-box.component';
import { MessageBoxComponent } from 'src/app/modals/message-box/message-box.component';
import { Beneficiaria } from 'src/app/model/beneficiaria';
import { Paginador } from 'src/app/model/configuracion';
import { BeneficiariaService } from 'src/app/services/beneficiaria.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { CsvService } from 'src/app/services/csv.service';
import { ParametrosService } from 'src/app/services/parametros.service';
import { SesionService } from 'src/app/services/sesion.service';

const ELEMENT_DATA: Beneficiaria[] = [];


@Component({
  selector: 'app-gestor-expedientes-medicos',
  templateUrl: './gestor-expedientes-medicos.component.html',
  styleUrls: ['./gestor-expedientes-medicos.component.scss']
})
export class GestorExpedientesMedicosComponent implements OnInit {

  
  displayedColumns: string[] = ['gexm_position','gexm_nombre', 'gexm_estatus','gexm_etapa', 'gexm_motivo_ingreso', 'gexm_discapacidad','gexm_canalizador'];
  dataSource = new MatTableDataSource<Beneficiaria>(ELEMENT_DATA);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  pageEvent: PageEvent;
  canalizadores:any;
  motivosDeIngreso:any;
  isEvaluaciones:boolean = false;
  phpPath:string;
  acciones:any=[];
  tieneAccionCrear = false;
  tieneAccionEliminar = false;
  tieneAccionEditar = false;
  isLoading = false;
  paginador:Paginador;
  constructor(
    public gexm_csvService:CsvService,
    public gexm_activatedRoute:ActivatedRoute,
    public dialog: MatDialog,
    private gexm_beneficiariaService:BeneficiariaService,
    private gexm_config:ConfigurationService,
    private gexm_parametros:ParametrosService,
    private gexm_sesion:SesionService,
    private _conf:ConfigurationService
    ) { 
      this.phpPath=_conf.getConfiguration().embedPhpPath;
    this.paginador = this.gexm_config.getConfiguration().ui.paginador;
    this.gexm_activatedRoute.url.subscribe(url=>{
      this.isEvaluaciones = url[0].path.indexOf("evaluaciones") >-1;

      if(this.isEvaluaciones){
        this.displayedColumns.push('gexm_habilidades');
      }else{
        this.displayedColumns.push('gexm_mas');
      }
    });
    this.tieneAccionEliminar = this.cau("/beneficiarias/delete");
    console.log("this.tieneAccionEliminar: ", this.tieneAccionEliminar);
    this.tieneAccionEditar = this.cau("/beneficiarias/datos-generales");
    console.log("this.tieneAccionEditar: ", this.tieneAccionEditar);
    this.tieneAccionCrear = this.cau("/beneficiarias/datos-generales");
    console.log("this.tieneAccionCrear: ", this.tieneAccionCrear);
  }

  formulario = new UntypedFormGroup({
    buscar:new UntypedFormControl("",[]),
    estatus:new UntypedFormControl("",[])
  })

  cau(urlRecibida){
    if(this.gexm_sesion.getSession().getUsuario().nombre!=undefined){
      this.acciones = this.gexm_sesion.getSession().getAcciones();
      if(this.acciones.filter(x => x.url == urlRecibida)[0]){
        return true;        
      }else{
        return false;
      }
    }else{
      return false;
    }
  }

  co(p){
    if(p == "Historico"){
      p = "Histórico";
    }
    return p.replace("ion","ión");
  }

  public laravelapi: any;
  ngOnInit(): void {
    this.laravelapi = this.gexm_beneficiariaService.getLaravelApi();
    this.dataSource.paginator = this.paginator;
    console.info("Entrando a beneficiarias");
    this.getEstatus();
    this.get_Canalizadores();
    this.get_MotivosDeIngreso();
    this.buscar(1,this.paginador.pageSize);
  }

  sF(){
    this.buscar(this.paginator.pageIndex+1,this.paginator.pageSize);
  }
  buscar(page:number,size:number){
    this.dataSource = new MatTableDataSource<Beneficiaria>([]);
    this.isLoading = true;
    this.gexm_beneficiariaService.findAll(this.formulario.controls["buscar"].value,this.formulario.controls["estatus"].value,page,size).subscribe(result=>{
      this.isLoading = false;
      console.info(result);
      this.paginator.length = result.data.count;
      this.getDiscapacidades(result.data.registros);
      
    },()=>{
      this.isLoading = false;
    });
  }
  getDiscapacidades(array:any){
    let ids = "";
    for(let i=0;i<array.length;i++){
      if(i+1==array.length){
        ids += array[i].id;
      }else{
        ids += array[i].id+",";
      }
    }
    this.gexm_beneficiariaService.findDiscapacidades(ids).subscribe(result=>{
      for(let i =0; i<result.data.length;i++){
        for(let x = 0; x<array.length;x++){
          if(array[x].id == result.data[i].id_beneficiaria && result.data[i].des_tipo_catalogo.length>0){
            array[x].idDiscapacidad = result.data[i].des_tipo_catalogo;
          }
        }
      }

      this.dataSource = new MatTableDataSource<Beneficiaria>(array);

    })
  }
  pr(event){
    this.paginator.pageSize = event.pageSize;
    this.paginator.pageIndex = event.pageIndex;
    this.buscar(event.pageIndex + 1 ,event.pageSize);
  }

  
  eliminar(id:number){
    this.isLoading = true;
    this.gexm_beneficiariaService.deleteById(id).subscribe(result=>{
      this.isLoading = false;
      this.dialog.open(MessageBoxComponent, {
        data: {titulo: "Expediente eliminado", mensaje: "El expediente ha sido eliminado", desicion:true}
      });
      this.buscar(1,this.paginator.pageSize);
    },()=>{
      this.isLoading = false;
    });
  }
  estados:any[];
  getEstatus(){
    this.gexm_parametros.getParametros("1").subscribe(result=>{
      if(result.codigo = "PRM000"){
        this.estados = result.data.parametros;
      }
    },()=>{
      this.estados = [];
    })
  }
  getMotivoIngresoById(id){
    for(let i=0; i<this.motivosDeIngreso.length; i++){
      if(this.motivosDeIngreso[i].idParametro == id ){
        return this.motivosDeIngreso[i].valor;
      }
    }
    return "N/D";
  }
  get_Canalizadores(){
    //param canaliza
    this.gexm_parametros.getParametros("2").subscribe(result=>{
      this.canalizadores = result.data.parametros;
    });
  }
  get_MotivosDeIngreso(){
    this.gexm_parametros.getParametros("3").subscribe(result=>{
      this.motivosDeIngreso = result.data.parametros;
    });
  }
  getEstatusById(id:string){
    for(let ikkk=0; ikkk<this.estados.length; ikkk++){
      if(this.estados[ikkk].idParametro == id ){
        return this.estados[ikkk].valor;
      }
    }
    return "N/D";
  }

  getCanalizadorById(id){
    for(let a=0; a<this.canalizadores.length; a++){
      if(this.canalizadores[a].idParametro == id ){
        return this.canalizadores[a].valor;
      }
    }
    return "N/D";
  }

  
  exportarCSV(){
    this.isLoading = true;
    this.gexm_beneficiariaService.exportarCSV().subscribe(result=>{
      this.isLoading = false;
      console.info(result);
      this.gexm_csvService.downloadFile(result.data,"beneficiarias-reporte-"+new Date().toLocaleString()+"");
    },()=>{
      this.isLoading = false;
    });
  }
  
  filtroEstatus(etapa){
    let etapas = this.gexm_config.getConfiguration()["etapasActivas"];
    if(etapas.indexOf(etapa.toUpperCase())>-1){
      return "ACTIVO";
    }else{
      return "NO ACTIVO";
    }
  }

  confirmaEliminacion(id:number): void {
    const dialogRef = this.dialog.open(DesitionBoxComponent, {
      data: {titulo: "Eliminando expediente", mensaje: "Está eliminando un expediente, la información no podrá ser recuperada, ¿Desea continuar?", desicion:true}
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log('The dialog was closed');
      if(result){
        this.eliminar(id);
      }
    });
  }


  

}



export const exportToCsv = (filename: string, rows: object[], headers?: string[]): void => {
  
  checkExistRow(rows);
  // if (!rows || !rows.length) {
  //     return;
  // }
  const separator: string = ",";

  const keys: string[]  = Object.keys(rows[0]);

  // let columHearders: string[];
  let columHearders = checkExistHeader(headers,keys);

  // if (headers) {
  //     columHearders = headers;
  // } else {
  //     columHearders = keys;
  // }

  const csvContent =
      "sep=,\n" +
      columHearders.join(separator) +
      '\n' +
      rows.map(row => {
          return keys.map(k => {
            let cell = assignValueCell(row, k);
              // let cell = row[k] === null || row[k] === undefined ? '' : row[k];

              cell = cell instanceof Date 
                  ? cell.toLocaleString()
                  : cell.toString().replace(/"/g, '""');

              if (navigator.msSaveBlob) {
                  cell = cell.replace(/[^\x20-\x7F]/g, ""); //remove non-ascii characters
              }
              if (cell.search(/("|,|\n)/g) >= 0) {
                  cell = `"${cell}"`;
              }
              return cell;
          }).join(separator);
      }).join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) { // In case of IE 10+
      navigator.msSaveBlob(blob, filename);
  } else {
      const link = document.createElement('a');
      if (link.download !== undefined) {
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
      }
  }








  
}

export function checkExistRow(rows){
  if (!rows || !rows.length) {
    return;
  }
}

export function checkExistHeader(headers, keys){
  if (headers) {
    return headers;
  } else {
    return keys;
  }
}


export function assignValueCell(row, k){
  if (row[k] === null || row[k] === undefined) {
    return '';
  } else {
    return row[k];
  }
}